"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudyCaptureStatusExportFormat = exports.GetStudyCaptureStatusBySiteDownloadUrlResponse = exports.GetStudyCaptureStatusBySubjectDownloadUrlResponse = exports.GetStudyCaptureStatusByVisitDownloadUrlResponse = exports.GetStudyCaptureStatusByCrfDownloadUrlResponse = exports.GetStudyStudyCaptureStatusByCrfResponse = void 0;
class GetStudyStudyCaptureStatusByCrfResponse {
}
exports.GetStudyStudyCaptureStatusByCrfResponse = GetStudyStudyCaptureStatusByCrfResponse;
class GetStudyCaptureStatusByCrfDownloadUrlResponse {
}
exports.GetStudyCaptureStatusByCrfDownloadUrlResponse = GetStudyCaptureStatusByCrfDownloadUrlResponse;
class GetStudyCaptureStatusByVisitDownloadUrlResponse {
}
exports.GetStudyCaptureStatusByVisitDownloadUrlResponse = GetStudyCaptureStatusByVisitDownloadUrlResponse;
class GetStudyCaptureStatusBySubjectDownloadUrlResponse {
}
exports.GetStudyCaptureStatusBySubjectDownloadUrlResponse = GetStudyCaptureStatusBySubjectDownloadUrlResponse;
class GetStudyCaptureStatusBySiteDownloadUrlResponse {
}
exports.GetStudyCaptureStatusBySiteDownloadUrlResponse = GetStudyCaptureStatusBySiteDownloadUrlResponse;
var StudyCaptureStatusExportFormat;
(function (StudyCaptureStatusExportFormat) {
    StudyCaptureStatusExportFormat["Excel"] = "XLS";
})(StudyCaptureStatusExportFormat = exports.StudyCaptureStatusExportFormat || (exports.StudyCaptureStatusExportFormat = {}));
//# sourceMappingURL=studyCaptureStatus.js.map